import styled from 'styled-components';

const MobileMenuButtonContainer = styled.li`
  cursor: pointer;
  width: 20px;
  height: 20px;
  margin: 0;
  position: relative;
  z-index: 99;
  bottom: 3px;

  @media (max-width: 1199px) {
    padding: 0 15px;
    display: block;
  }
`;

export { MobileMenuButtonContainer };
